import { render } from "./MarkPresent.vue?vue&type=template&id=19add278&scoped=true"
import script from "./MarkPresent.vue?vue&type=script&lang=js"
export * from "./MarkPresent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19add278"]])

export default __exports__